import { Button } from '@starsoft/common/components';
import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import { useModalNavigation } from '@/hooks/modals/useModalNavigation';
import { ModalsKey } from '@/enums/modalsKey';
import { CoinType } from '@starsoft/common/models';

export default function Buttons() {
  const { t } = useTranslation('common');
  const { navigateToModal } = useModalNavigation();

  return (
    <div className={styles['box']}>
      <div className={styles['box__row']}>
        <Button onClick={() => navigateToModal(ModalsKey.Deposit)}>
          {t('deposit_button')}
        </Button>
        <Button onClick={() => navigateToModal(ModalsKey.Withdraw)}>
          {t('withdraw_button')}
        </Button>
      </div>
      <div className={styles['box__row']}>
        <Button
          isSecondary
          onClick={() =>
            navigateToModal(ModalsKey.Deposit, `?coin-type=${CoinType.Crypto}`)
          }
        >
          {t('deposit_crypto_button')}
        </Button>
      </div>
    </div>
  );
}
